var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"message",class:( _obj = {}, _obj[("message--" + _vm.severity)] = _vm.severity, _obj )},[_c('div',{staticClass:"message__content"},[_vm._t("default",function(){return [_c('div',[(_vm.title)?_c('div',{staticClass:"message__title"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_c('div',{staticClass:"message__text"},[_vm._v(_vm._s(_vm.text))])])]})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }